import { theme } from '@global-engineering-shared/gweb-material-theme-next';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  card: {
    padding: theme.spacing(0, 2, 1, 2),
  },
  header: {
    fontSize: '14px',
    height: '24px',
    fontWeight: 600,
    color: '#1F3160',
  },
  titleDivider: {
    marginBottom: theme.spacing(2),
  },
  rowDivider: {
    margin: theme.spacing(1, 0, 1, 0),
  },
});

export default useStyles;
